module.exports = __webpack_public_path__ + "img/logo.60d408a2.png";